var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-color",on:{"click":_vm.setCanvasToolColor}},[_c('div',{staticClass:"inner-color",style:('background-color:' + _vm.boxCanvasToolColor)})])}
var staticRenderFns = []

export { render, staticRenderFns }